import { defineComponent, watch, ref } from "vue";
export default defineComponent({
    props: {
        machineAudit: {
            type: Object,
            default: function() {
                return {};
            }
        },
        creativeType: {
            type: String,
            default: ""
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit, attrs = param.attrs;
        var setVideoCurrentTime = function setVideoCurrentTime(time) {
            emit("setVideoCurrentTime", time);
        };
        var getRiskLevel = function getRiskLevel(level) {
            if (level === "high") {
                return "\u9AD8\u98CE\u9669";
            } else if (level === "none") {
                return "\u65E0\u98CE\u9669";
            } else if (level === "medium") {
                return "\u4E2D\u98CE\u9669";
            } else if (level === "low") {
                return "\u4F4E\u98CE\u9669";
            }
            return "-";
        };
        var audit_info = ref({});
        var status = ref(-1);
        watch(function() {
            return props.machineAudit;
        }, function(val) {
            if (val && JSON.stringify(val) !== "{}") {
                audit_info.value = JSON.parse(val.audit_info);
                status.value = val.status;
            } else {
                status.value = 0;
            }
        });
        return {
            audit_info: audit_info,
            status: status,
            setVideoCurrentTime: setVideoCurrentTime,
            getRiskLevel: getRiskLevel
        };
    }
});
